import { useEffect } from 'react';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';

import { useGetConfigTelegramQuery, useUpdateConfigTelegramMutation } from '../store/config-api';

import type { TConfigTelegram } from '../store/types';

type FormData = TConfigTelegram;

export const useConfigTelegram = () => {
  const {
    data,
    isLoading: isGetLoading,
    isSuccess: isGetSuccess,
    isError: isGetError,
  } = useGetConfigTelegramQuery();

  const [updateTelegram, {
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess,
    isError: isUpdateError,
  }] = useUpdateConfigTelegramMutation();

  const isLoading = isGetLoading || isUpdateLoading;
  const isSuccess = isUpdateSuccess;
  const isError = isGetError || isUpdateError;

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      botToken: data?.botToken || '',
      depositsChatId: data?.depositsChatId || '',
      withdrawalsChatId: data?.withdrawalsChatId || '',
    },
    validate: {
      botToken: (value) => !value ? 'Введите token бота' : null,
      depositsChatId: (value) => !value ? 'Введите ID чата для платежей' : null,
      withdrawalsChatId: (value) => !value ? 'Введите ID чата для выводов' : null,
    },
  });

  const handleTelegramUpdate = async (params: TConfigTelegram) => {
    await updateTelegram(params);
  };

  useEffect(() => {
    if (isGetSuccess) {
      form.setValues({ ...data });
    }
  }, [isGetSuccess]);

  const handleSubmit = (values: FormData) => {
    modals.openConfirmModal({
      title: 'Сохранение настроек Телеграм бота',
      centered: true,
      children: 'Вы точно хотите сохранить настройки Телеграм бота?',
      labels: { confirm: 'Подтвердить', cancel: 'Отмена' },
      confirmProps: { color: 'blue' },
      onConfirm: () => handleTelegramUpdate(values),
    });
  };

  return {
    // data,
    isLoading,
    form,
    handleSubmit,
  };
};
